import React, { ReactNode } from 'react';

type IconButtonProps = {
    onClick: () => void;
    icon: ReactNode;
    label?: string;
}

export const IconButton = ({
  onClick,
  icon,
  label,
}: IconButtonProps) => {
  return (
    <button
        type='button'
        aria-label={label}
        title={label}
        className='flex h-8 w-8 shrink-0 items-center justify-center rounded-md border border-slate-200 bg-white p-1.5 text-slate-700 transition hover:border-emerald-400 hover:bg-emerald-50 hover:text-emerald-700 sm:h-9 sm:w-9 sm:p-2'
        onClick={onClick}
    >
      { icon }
    </button>
  );
};
